// ============================================================================
// TASKREF - Referencia corta de tarea (CERTI-123)
// ============================================================================
// Usa el prefijo del tenant (clients.task_prefix vía get_public_config) y el
// task_number secuencial. Fallback al formato legacy TASK-XXXX (últimos 4 del
// id) mientras la migración de numeración no esté ejecutada.

import appConfig from '../config/appConfig';

export function getTaskRef(task) {
  const prefix = appConfig.getTaskPrefix();
  if (prefix && task?.task_number) {
    return `${prefix}-${task.task_number}`;
  }
  const shortId = task?.id?.toString().slice(-4)?.toUpperCase() || '????';
  return `TASK-${shortId}`;
}

// Patrón de referencia en URLs: LETRAS-número (CERTI-106).
// Los ids legacy (task-20260603-953679, 20260608-abc123) nunca casan.
const REF_PATTERN = /^[A-Za-z]{1,10}-(\d+)$/;

// Slug para URLs del detalle: la referencia si hay numeración, el id si no
export function getTaskSlug(task) {
  const prefix = appConfig.getTaskPrefix();
  if (prefix && task?.task_number) {
    return `${prefix}-${task.task_number}`;
  }
  return task?.id;
}

export function getTaskPath(task) {
  return `/task/detail/${getTaskSlug(task)}`;
}

// ¿El parámetro de la URL (id legacy o referencia CERTI-106) es esta tarea?
export function taskMatchesParam(task, param) {
  if (!task || !param) return false;
  if (task.id === param) return true;
  const m = param.match(REF_PATTERN);
  return !!(m && task.task_number && Number(m[1]) === Number(task.task_number));
}
